// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MyHistory_wrap__1VFGX","myHistory":"MyHistory_myHistory__2o1dn","content":"MyHistory_content__tl0JC","title":"MyHistory_title__DXLth","blocks":"MyHistory_blocks__1Ft7H"};